import Anchor from './Anchor';
import AnchorLink from './AnchorLink';
Anchor.Link = AnchorLink;
export default Anchor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/anchor/index.js
// module id = 578
// module chunks = 0